// client/src/components/BookingCardSkeleton.js

import React from 'react';
import { Col, Card, Placeholder, Row } from 'react-bootstrap';

const BookingCardSkeleton = () => (
  <Col md={6}>
    <Card className="mb-3 p-3 shadow-sm border-0 bg-light">
      <Card.Body>
        <div className="d-flex justify-content-between align-items-center">
          <Placeholder as={Card.Title} animation="glow">
            <Placeholder xs={6} />
          </Placeholder>
          <Placeholder as="div" animation="glow">
             <Placeholder xs={3} />
          </Placeholder>
        </div>
        <Placeholder as={Card.Subtitle} animation="glow" className="mb-2">
          <Placeholder xs={4} />
        </Placeholder>
        <Placeholder as={Card.Text} animation="glow">
          <Placeholder xs={7} /> <br />
          <Placeholder xs={5} />
        </Placeholder>
        <Placeholder.Button variant="primary" xs={3} className="me-2" />
        <Placeholder.Button variant="secondary" xs={4} />
      </Card.Body>
    </Card>
  </Col>
);

export default BookingCardSkeleton;